var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"container"},[(_vm.player.thumb.current && _vm.container)?_c('div',{class:{'full': _vm.fullHeight, 'pp-ui-thumbnail': true },style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.current)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }